import { type DataURL } from "../../../../../packages/excalidraw/types";

export interface imageData {
  dataURL: DataURL;
  name: string;
  width: number;
  height: number;
}

const readImageaAsBase64 = (): Promise<imageData> => {
  return new Promise((resolve, reject) => {
    try {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const image = new Image();
            image.src = e.target?.result as string;
            image.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = image.width;
              canvas.height = image.height;
              const ctx = canvas.getContext("2d");
              ctx?.drawImage(image, 0, 0);
              const dataURL = canvas.toDataURL("image/png") as DataURL;
              // debugger;
              resolve({
                dataURL,
                name: file.name,
                width: image.width,
                height: image.height,
              });
            };
          };
          reader.readAsDataURL(file);
        }
      };
      input.click();
    } catch (error) {
      reject(error);
    }
  });
};

export const readImageUrlAsBase64 = (url: string): Promise<imageData> => {
  const cache = new Map();

  if (cache.has(url)) {
    return cache.get(url);
  }

  return new Promise((resolve, reject) => {
    try {
      // debugger;
      const image = new Image();
      image.crossOrigin = "anonymous"; // Enable CORS
      image.src = url;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL("image/png") as DataURL;

        // Extract filename from URL
        const name = url.split("/").slice(-2).join("_") || "image.png";
        const base64Data = {
          dataURL,
          name,
          width: image.width,
          height: image.height,
        };
        cache.set(url, base64Data);

        resolve(base64Data);
      };

      image.onerror = () => {
        reject(new Error("Failed to load image from URL"));
      };
    } catch (error) {
      reject(error);
    }
  });
};
